import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import 'rxjs';
import { Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { Router } from '@angular/router';
import { User } from '../models/user';
@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient, private router: Router) { }

  private User: User = new User();
  private User$ = new Subject<User>();

  private Login: boolean = false;
  private Login$ = new Subject<boolean>();

  changeUser(val) {
    this.User = val;
    this.User$.next(this.User);
  }
  getUser$(): Observable<User> {
    return this.User$.asObservable();
  }

  changeLogin(val) {
    this.Login = val;
    this.Login$.next(this.Login);
  }
  getLogin$(): Observable<boolean> {
    return this.Login$.asObservable();
  }

  login(data) {
    return this.http.post(environment.apiUrl + 'login', data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

  setLogin(data) {
    if (data.success) {
      localStorage.setItem('token', data.token.token);
      localStorage.setItem('name', data.token.name);
      localStorage.setItem('email', data.token.email);
      localStorage.setItem('id', data.token.id);
      this.changeLogin(true);
      this.changeUser(data.token);

      //this.router.navigate(['panel']);
    } else {
      this.changeLogin(false);
      this.changeUser(null);

      this.router.navigate(['login']);
    }
  }

  checkLogin() {
    var session = localStorage.getItem("token");

    if (session == null) {
      this.changeLogin(false);
      this.changeUser(null);
      this.router.navigate(['login']);
      //return false;
    }
    else {
      this.changeLogin(true);
      this.router.navigate(['dashboard']);
      //return localStorage;
    }


  }

  checkUser() {

    var session = localStorage.getItem("id");

    if (session == null) {
      this.changeLogin(false);
      this.changeUser(null);
      this.router.navigate(['login']);
      return false;
    }
    return session;

  }

  logout() {
    this.dbLogOut().subscribe(response => {
      localStorage.clear();
      this.changeLogin(false);
      this.router.navigate(['login']);
    })
  }

  dbLogOut(): Observable<Object> {

    return this.http.get(environment.apiUrl + 'logout?token=' + localStorage.getItem("token"))
      .pipe(
        map(
          (res: any) => {
            return res;
          }
        ),
        catchError(
          e => {
            if (e.status === 401) {
              localStorage.clear();
              this.changeLogin(false);
              this.router.navigate(['login']);
            }
            return throwError(e);

          }

        )
      );

  }
}
